export default "__VITE_PUBLIC_ASSET__136e50e6__"